import React, { useState, useEffect } from "react";
import { Menu, ShoppingCart, X } from "lucide-react";
import logo from "../assets/image/Logo.jpeg";

export default function Navbar({ setCartOpen, cartItemCount }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  // Efeito para detectar quando o usuário rola a página
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Objeto com os links de navegação
  const navLinks = [
    { name: "Home", href: "#home" },
    { name: "Nossos Produtos", href: "#produtos" },
    { name: "Quem somos", href: "#quemsomos" },
    { name: "Contato", href: "#contato" }
  ];

  return (
    <header
      className={`sticky top-0 z-50 transition-all duration-300 ease-in-out ${
        scrolled
          ? "bg-white shadow-lg text-gray-800"
          : "bg-green-800 text-white"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex-shrink-0">
            {/* O logo agora também é um link para o topo */}
            <a href="#home" className="flex items-center ">
              <img src={logo} alt="InsetoBras Logo" className="h-32"/>
              <span className={`text-2xl font-bold transition-colors ${
                scrolled ? 'text-green-800' : 'text-white'
              }`}>
                InsetoBras
              </span>
            </a>
          </div>

          {/* Menu central (desktop) */}
          <nav className="hidden md:flex items-center gap-10 text-base font-semibold">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href} // <-- MUDANÇA AQUI
                className="relative py-2 group"
                onClick={() => setMenuOpen(false)} // Fecha o menu mobile ao clicar (boa prática)
              >
                <span>{link.name}</span>
                <span className={`absolute bottom-0 left-0 w-full h-0.5 transition-transform duration-300 ease-out origin-left transform scale-x-0 group-hover:scale-x-100 ${
                  scrolled ? 'bg-green-700' : 'bg-orange-500'
                }`}></span>
              </a>
            ))}
          </nav>

          {/* Botões e Ícones */}
          <div className="flex items-center gap-4">
            <a
              href="https://wa.me/5561981531285?text=Ei!%20%F0%9F%98%84%20Acabei%20de%20dar%20uma%20passadinha%20pelo%20site%20da%20loja%20e%20fiquei%20curioso%20sobre%20os%20insetos%20que%20voc%C3%AAs%20vendem!%20Pode%20me%20ajudar%3F"
              target="_blank"
              rel="noopener noreferrer"
              className={`px-5 py-2 rounded-full text-sm font-bold transition-all duration-300 hidden md:block 
                ${scrolled ? 'bg-green-700 text-white hover:bg-green-800' : 'bg-orange-500 text-white hover:bg-orange-600'}`}
            >
              Fale conosco
            </a>
            
            <div className="relative cursor-pointer p-2 rounded-full transition-colors hover:bg-white/20" onClick={() => setCartOpen(true)}>
              <ShoppingCart className="w-6 h-6" />
              {cartItemCount > 0 && (
                <span className="absolute top-0 right-0 bg-red-500 text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center animate-pulse">
                  {cartItemCount}
                </span>
              )}
            </div>
            
            <button
              className="md:hidden p-2"
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="Abrir menu"
            >
              {menuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>
      </div>

      {/* Menu Mobile */}
      <div className={`md:hidden overflow-hidden transition-all duration-300 ease-in-out ${
        scrolled ? 'bg-white text-gray-800' : 'bg-green-800/90 backdrop-blur-sm text-white'
      } ${menuOpen ? "max-h-96" : "max-h-0"}`}>
        <div className="px-4 pt-2 pb-4 space-y-2">
          {navLinks.map((link) => (
            <a 
              key={link.name} 
              href={link.href} // <-- MUDANÇA AQUI
              className="block py-2 text-lg font-medium hover:bg-white/10 rounded-md px-3"
              onClick={() => setMenuOpen(false)} // Fecha o menu ao clicar
            >
              {link.name}
            </a>
          ))}
          {/* O botão agora é um link, igual ao do desktop */}
          <a
            href="https://wa.me/5561981531285?text=Ei!%20%F0%9F%98%84%20Acabei%20de%20dar%20uma%20passadinha%20pelo%20site%20da%20loja%20e%20fiquei%20curioso%20sobre%20os%20insetos%20que%20voc%C3%AAs%20vendem!%20Pode%20me%20ajudar%3F"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full mt-2 bg-orange-500 hover:bg-orange-600 text-white px-4 py-3 rounded-md text-center font-bold block"
          >
            Fale conosco
          </a>
        </div>
      </div>
    </header>
  );
}

